import angular from 'angular'
import forEach from 'lodash/forEach'

angular.module('vend.ui').directive('vdTabs', function (elementService) {
  return {
    scope: { model: '=' },
    transclude: true,
    template: '<ng-transclude></ng-transclude>',
    link(scope, $element, attrs) {
      const modifiers = elementService.getComponentAttrs(attrs, 'modifier')

      attrs.$addClass('vd-tabs')

      if (modifiers) {
        forEach(modifiers, modifier => attrs.$addClass(`vd-tabs--${modifier}`))
      }
    },
    controller($scope, $element) {
      /**
       * Sets all other tabs to inactive, and sets the clicked tab to active.
       *
       * @method setActiveTab
       *
       * @param  {Object} tab
       *         The tab to set as active.
       *
       * @param  {Any} value
       *         The selected tab value
       */
      this.setActiveTab = (tab, value) => {
        const tabs = $element.children().children()

        forEach(tabs, tab => angular.element(tab).removeClass('vd-tab--active'))

        angular.element(tab).addClass('vd-tab--active')
        $scope.model = value
      }
    },
  }
})
